import * as React from "react";
import ChatBubbleHybrid from "./ChatBubbleHybrid";
import type { TypeChatBubbleProps } from "./ChatBubbleTypes";

/**
 * ChatBubble component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or styled() extension).
 */
const ChatBubble = (props: TypeChatBubbleProps) => (
  <ChatBubbleHybrid {...props} />
);

export default ChatBubble;
